import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { DocumentUploadDispatchTypes } from "../models/DispatchTypes/TabSessionStorage";
import {
  DocumentUploadActionDispatchTypes,
  DocumentDeleteActionDispatchTypes,
} from "../constants/DocumentUpload";
import { PostDocument, DeleteDocument } from "../services/DocumentUpload";
import { configUrl } from "../constants/Config";

export const UploadDocument: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentUploadDispatchTypes
  >
> = (file: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentUploadActionDispatchTypes.DOCUMENT_UPLOAD_INVOKE,
    });
    const response = await PostDocument(configUrl, file);
    dispatch({
      response,
      type: DocumentUploadActionDispatchTypes.DOCUMENT_UPLOAD_SUCCESS,
    });
  };
};

export const DeleteBlobId: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentUploadDispatchTypes
  >
> = (blobId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentDeleteActionDispatchTypes.DOCUMENT_DELETE_INVOKE,
    });
    const response = await DeleteDocument(configUrl, blobId);
    dispatch({
      response,
      type: DocumentDeleteActionDispatchTypes.DOCUMENT_DELETE_SUCCESS,
    });
  };
};
